import { ConfirmDelete } from "components/ConfirmDialog/ConfirmDelete";
import { ConfirmDeleteTarget } from "models/ConfirmDeleteTarget";
import { useAgendaItem } from "providers";
import { useApi } from "providers";
import { useMeeting } from "providers";
import { useToasts } from "providers";
import { useTranslations } from "providers";
import { useCallback } from "react";

export const ConfirmDeleteAgendaItem: React.FC = () => {
  const i18n = useTranslations();
  const toasts = useToasts();
  const { reloadMeeting } = useMeeting();
  const { agendaItemsApi } = useApi();
  const { confirmDeleteAgendaItem, setConfirmDeleteAgendaItem, setAgendaItemDeleting } = useAgendaItem();

  const isOpen = confirmDeleteAgendaItem !== undefined;

  const handleDelete = useCallback(
    async (target?: ConfirmDeleteTarget) => {
      if (!target) return;

      setConfirmDeleteAgendaItem(undefined);
      setAgendaItemDeleting(target.id, true);

      try {
        await agendaItemsApi.delete(target.id);
      } catch (error) {
        toasts.deleteFailure(i18n.AgendaItem, target.title, error);
      } finally {
        reloadMeeting().finally(() => {
          setAgendaItemDeleting(target.id, false);
        });
      }
    },
    [agendaItemsApi, reloadMeeting, setAgendaItemDeleting, setConfirmDeleteAgendaItem, i18n, toasts]
  );

  const setIsOpen = useCallback(
    (open: boolean) => {
      if (!open) {
        setConfirmDeleteAgendaItem(undefined);
      }
    },
    [setConfirmDeleteAgendaItem]
  );

  return (
    <ConfirmDelete
      entityName={i18n.AgendaItem}
      entityTitle={confirmDeleteAgendaItem?.title}
      content={i18n.Actions_Delete_AgendaItem_Confirm}
      onAccept={() => handleDelete(confirmDeleteAgendaItem)}
      onCancel={() => setConfirmDeleteAgendaItem(undefined)}
      isOpen={isOpen}
      setIsOpen={setIsOpen}
    />
  );
};
